module.exports = __webpack_public_path__ + "band_3.df6812c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_3.png
// module id = 8xRs
// module chunks = 0